import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Gift, Copy, Share2, Users } from "lucide-react";

export const InviteEarnCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/referrals/me").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(data.link);
      toast.success("Invite link copied!");
    } catch {
      toast.error("Could not copy — long-press the link to copy it");
    }
  };

  const share = async () => {
    const text = `Join me on ZEEPTEL — call any phone worldwide with prepaid credit. Sign up with my link: ${data.link}`;
    if (navigator.share) {
      try { await navigator.share({ title: "ZEEPTEL", text, url: data.link }); } catch { /* dismissed */ }
    } else {
      copy();
    }
  };

  return (
    <div className="bg-white border border-black/10 rounded-2xl p-6 shadow-sm" data-testid="invite-earn-card">
      <div className="flex items-center gap-2 mb-1">
        <Gift className="h-5 w-5 text-rose-600" />
        <h2 className="font-heading font-bold text-lg">Invite friends, earn airtime</h2>
      </div>
      <p className="text-sm text-zinc-500 mb-4">
        Get <b>${data.reward_per_friend.toFixed(2)} free airtime</b> for every friend who signs up with your link and makes their first call.
      </p>

      <div className="flex items-center gap-2 mb-4">
        <div className="flex-1 bg-zinc-50 border border-zinc-200 rounded-xl px-3 py-2.5 text-sm font-mono truncate" data-testid="referral-link">
          {data.link}
        </div>
        <button onClick={copy} className="p-2.5 rounded-xl border border-zinc-200 hover:bg-zinc-50 transition-colors" data-testid="referral-copy-button" title="Copy link">
          <Copy className="h-4 w-4" />
        </button>
        <button onClick={share} className="p-2.5 rounded-xl bg-primary text-white hover:opacity-90 transition-opacity" data-testid="referral-share-button" title="Share">
          <Share2 className="h-4 w-4" />
        </button>
      </div>

      <div className="grid grid-cols-3 gap-3 text-center">
        <div className="bg-zinc-50 rounded-xl py-3" data-testid="referral-invited-stat">
          <div className="text-xl font-bold">{data.invited}</div>
          <div className="text-xs text-zinc-500 flex items-center justify-center gap-1"><Users className="h-3 w-3" /> Joined</div>
        </div>
        <div className="bg-zinc-50 rounded-xl py-3" data-testid="referral-rewarded-stat">
          <div className="text-xl font-bold">{data.rewarded}</div>
          <div className="text-xs text-zinc-500">Made a call</div>
        </div>
        <div className="bg-emerald-50 rounded-xl py-3" data-testid="referral-earned-stat">
          <div className="text-xl font-bold text-emerald-600">${data.earned.toFixed(2)}</div>
          <div className="text-xs text-emerald-700">Earned</div>
        </div>
      </div>
    </div>
  );
};
